import React, { useContext, useEffect, useState } from 'react'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import PlusIcon from '../../../assets/plus-icon.svg'
import AttachLink from '../attachLink'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail, validateLink } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'
import TemplateAccordion from '../templateAccordion'
import { isEmpty } from 'lodash'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LinkIcon from '../../../assets/link-icon.svg'
import DeleteIcon from '../../../assets/delete-icon.svg'
import DesignSettingOverlay from '../designSettingOverlay'

const MiamiFoxHeaderModal = ({
  componentData,
  modifyData,
  modalSpecificData,
  onCancel,
  isAdvancedEditAllowed,
}) => {
  // const { isEdit } = modalSpecificData
  const { userSessionObj } = useContext(GlobalContext)
  const { loader, setLoader } = useContext(AppContext)

  const [logoS3key, setLogoS3key] = useState('')
  const [siteMap, setSiteMap] = useState([])
  const [link, setLink] = useState({ type: '', data: {} }) // default footer form subscribe btn link
  const [socialHandles, setSocialHandles] = useState([])
  const [linkModal, setLinkModal] = useState(false)
  const [headingLinkModal, setHeadingLinkModal] = useState(false)
  const [siteMapIdx, setSiteMapIdx] = useState(0)
  const [subHeadingIndex, setSubHeadingIndex] = useState(0)
  const [addButton1, setAddButton1] = useState({
    enabled: false,
    text: '',
    link: { type: '', data: {} },
  })
  const [addButton2, setAddButton2] = useState({
    enabled: false,
    text: '',
    link: { type: '', data: {} },
  })
  const [menuButton, setMenuButton] = useState({
    enabled: false,
    text: '',
    link: { type: '', data: {} },
  })
  const [styleConfig, setStyleConfig] = useState({})
  const [designSettingOptions, setDesignSettingOptions] = useState([])

  const [errorData, setErrorData] = useState({})
  const [imageData, setImageData] = useState([])

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  useEffect(() => {
    const imgData = [
      {
        title: '',
        customUploadText: 'Upload Logo',
        id: 'mdImage',
        width: 157,
        height: 70,
        divwidth: '14.67rem',
        divheight: '8.25rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          setLogoS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setLogoS3key('')
        },
        imageUrl: '',
      },
    ]

    let tempdata = componentData.data
    // console.log(tempdata)
    if (tempdata?.style_config) {
      setStyleConfig(tempdata?.style_config)
    }

    setLogoS3key(tempdata.logo_s3key)
    setSiteMap(tempdata.site_map)
    setAddButton1(tempdata.add_btn1)
    setAddButton2(tempdata.add_btn2)
    setMenuButton(tempdata.menu_btn)

    imgData[0]['assetId'] = tempdata.logo_s3key
    imgData[0]['imageUrl'] = getThumbnail(
      userSessionObj.session_data.cf_domain_name,
      tempdata.logo_s3key,
    )

    setImageData(imgData)
  }, [])

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (logoS3key.trim().length === 0) {
      isFormValid = false
      temp.logoS3key = 'Upload Image!'
    }

    // if (link.type && !validateLink(link).isValid) {
    //   isFormValid = false
    //   temp.link = validateLink(link).error
    // }

    setErrorData({ ...temp })
    return isFormValid
  }

  // save component data
  const handleSave = () => {
    if (!validateInfo()) return

    let elementObj = {
      logo_s3key: logoS3key,
      site_map: siteMap,
      add_btn1: addButton1,
      add_btn2: addButton2,
      menu_btn: menuButton,
      style_config: styleConfig,
    }

    modifyData(componentData.id, elementObj)
  }

  // delete social handle
  const deleteSiteMap = (index) => {
    setSiteMap((prevData) => prevData.filter((data, idx) => idx !== index))
  }

  // change social item Name
  const changeSocialItemName = (value, idx) => {
    let tempSocialHandles = socialHandles
    tempSocialHandles[idx] = { ...tempSocialHandles[idx], name: value }
    setSocialHandles([...tempSocialHandles])
  }

  // change site map item Name
  const changeSiteMapItemText = (value, idx) => {
    let tempSiteMap = siteMap
    tempSiteMap[idx] = { ...tempSiteMap[idx], title: value }
    setSiteMap([...tempSiteMap])
  }

  // change site map sub heading text
  const changeSiteMapItemSubHeadingText = (value, idx, index) => {
    if (isEmpty(siteMap)) return
    let tempSiteMap = siteMap
    let subHeadingData = tempSiteMap[idx]?.sub_heading_data
    subHeadingData[index] = { ...subHeadingData[index], text: value }
    tempSiteMap[idx] = { ...tempSiteMap[idx], sub_heading_data: subHeadingData }
    setSiteMap([...tempSiteMap])
  }

  const [subLinkError, setsubLinkError] = useState('')
  const [headLinkError, setHeadLinkError] = useState('')
  // change site map sub heading link
  const changeSiteMapItemSubHeadingLink = (value, idx, index) => {
    if (isEmpty(siteMap)) return
    if (!validateLink(value).isValid) {
      setsubLinkError(validateLink(value).error)
      return
    }
    let tempSiteMap = siteMap
    let subHeadingData = tempSiteMap[idx]?.sub_heading_data
    subHeadingData[index] = { ...subHeadingData[index], link: value }
    tempSiteMap[idx] = { ...tempSiteMap[idx], sub_heading_data: subHeadingData }
    setSiteMap([...tempSiteMap])
    setLinkModal(false)
  }

  // link modal opener
  const linkAssignModal = (idx, index) => {
    setLinkModal(true)
    setLink(siteMap[idx]?.sub_heading_data[index]?.link)
    setSiteMapIdx(idx)
    setSubHeadingIndex(index)
  }
  const changeSiteMapHeadingLink = (value, idx) => {
    if (isEmpty(siteMap)) return
    if (!validateLink(value).isValid) {
      setHeadLinkError(validateLink(value).error)
      return
    }
    let tempSiteMap = siteMap
    let itemData = tempSiteMap[idx]
    itemData = { ...itemData, link: value }
    tempSiteMap[idx] = { ...tempSiteMap[idx], link: itemData.link }
    setSiteMap([...tempSiteMap])
    setHeadingLinkModal(false)
  }
  // Sitemap Heading link modal opener
  const sitemapHeadingLinkAssignModal = (idx) => {
    if (siteMap[idx].sub_heading_data.some((item) => item.text.length > 0)) return
    console.log(siteMap[idx].sub_heading_data)
    setHeadingLinkModal(true)
    setLink(siteMap[idx].link)
    setSiteMapIdx(idx)
  }
  // Sitemap Heading link remover
  const removeSiteMapHeadingLink = (value, idx) => {
    if (!value) return
    let tempSiteMap = siteMap
    let itemData = tempSiteMap[idx]
    itemData = {
      ...itemData,
      link: {
        type: '',
        data: {},
      },
    }
    tempSiteMap[idx] = { ...tempSiteMap[idx], link: itemData.link }
    setSiteMap([...tempSiteMap])
  }

  // add site map
  const addSiteMap = () => {
    setSiteMap((prev) => [
      ...prev,
      {
        title: '',
        link: {
          type: '',
          data: {},
        },
        sub_heading_data: Array(15)
          .fill()
          .map((e) => ({
            text: '',
            link: {
              type: '',
              data: {},
            },
          })),
      },
    ])
  }

  const getStyleConfig = (keyArr = []) => {
    if (!componentData?.data?.style_config) {
      return []
    }
    let stylesArr = []
    for (let i = 0; i < keyArr.length; i++) {
      const key = keyArr[i]
      let styleObj = componentData?.data?.style_config[key]
      stylesArr.push(styleObj)
    }
    return stylesArr
  }

  const handleStyleSave = (data) => {
    let tempStyleObj = styleConfig
    for (let i = 0; i < data.length; i++) {
      const ele = data[i]
      tempStyleObj[ele.key] = ele
    }
    setStyleConfig({ ...tempStyleObj })
    setDesignSettingOptions([])
  }

  let accordionItems = [
    {
      title: 'Add Logo',
      description: "Insert company's logo in the Footer",
      children: (
        <div
          className="px-2 d-flex justify-content-around align-items-start"
          style={{ backgroundColor: '#e5e5e5' }}
        >
          <div>
            <ImageUploader data={imageData} />
            <div className="message-text error-message">
              <p>{errorData.logoS3key}</p>
            </div>
            <p style={{ fontSize: '10px', color: '#707070', textAlign: 'center' }}>
              Dimensions: 157 px X 70 px
            </p>
          </div>
        </div>
      ),
      itemStyle: '',
      enableColorPicker: isAdvancedEditAllowed && componentData?.data?.style_config,
      colorPickerFunction: () => {
        setDesignSettingOptions(getStyleConfig(['component_background']))
      },
    },
    {
      title: 'Edit Sitemap',
      description: 'Specify the Sitemap and respective links',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5', overflowX: 'auto', height: '370px' }}
          className=" px-4 py-1 d-flex custom-scrollbar-vertical custom-scrollbar-horizontal"
        >
          {!isEmpty(siteMap) &&
            siteMap.map((sitemapitem, idx) => {
              return (
                <div
                  className="flex-shrink-0 position-relative h-full"
                  style={{
                    width: '43%',
                    paddingRight: '9%',
                    borderRight: `${idx !== siteMap.length - 1 ? '1px #9b9494 solid' : 'none'}`,
                    marginLeft: `${idx === 0 ? '0' : '8%'} `,
                  }}
                  key={idx}
                >
                  <div
                    className={`position-absolute ${idx === 0 ? 'd-none' : 'd-block'}`}
                    onClick={() => deleteSiteMap(idx)}
                    style={{ right: '20%', top: '0', cursor: 'pointer' }}
                  >
                    <img src={DeleteIcon} alt="" style={{ width: '14px' }} />
                  </div>
                  <h6 style={{ fontSize: '13px' }} className="">
                    Menu {idx + 1}
                  </h6>
                  <div className="d-flex justify-content-between align-items-start mt-2">
                    <div style={{ width: '78%' }}>
                      <CustomDescriptionBox
                        limit={20}
                        rows={1}
                        value={sitemapitem.title}
                        onChange={(value) => changeSiteMapItemText(value, idx)}
                        style={{ fontSize: '10px', borderRadius: '3px' }}
                        limitFontSize={'11px'}
                      />
                    </div>
                    <div
                      className="w-7 h-7 d-flex justify-center items-center rounded-sm cursor-pointer"
                      onClick={() => sitemapHeadingLinkAssignModal(idx)}
                      style={{
                        background: sitemapitem?.sub_heading_data.some(
                          (item) => item?.text.length > 0,
                        )
                          ? '#7f817f'
                          : '#20211c',
                      }}
                    >
                      <img src={LinkIcon} alt="" className="w-3 h-3" />
                    </div>
                    {headingLinkModal && (
                      <CModal visible={headingLinkModal} size="md" alignment="center">
                        <CModalBody>
                          <h6 style={{ fontWeight: '700', fontSize: '12px' }}>ADD LINK</h6>
                          <AttachLink
                            title=""
                            linkData={link}
                            id={'text1'}
                            categoryData={
                              categoryList
                                ? categoryList?.data.filter(
                                    (info, idx) => info.type === 'category' && info.status,
                                  )
                                : []
                            }
                            setLinkData={(value) => {
                              setHeadLinkError('')
                              setLink(value)
                            }}
                          />
                          <div className="message-text error-message">
                            <p>{headLinkError}</p>
                          </div>
                        </CModalBody>
                        <CModalFooter style={{ borderTop: '0' }}>
                          <CButton
                            style={{
                              color: '#3a3838',
                              backgroundColor: 'white',
                              border: '1px solid #bdbdbd',
                              borderRadius: '5px',
                            }}
                            onClick={() => setHeadingLinkModal(false)}
                          >
                            Cancel
                          </CButton>
                          <CButton
                            style={{
                              color: 'white',
                              backgroundColor: '#20211c',
                              border: '1px solid #bdbdbd',
                              borderRadius: '5px',
                            }}
                            onClick={() => changeSiteMapHeadingLink(link, siteMapIdx)}
                          >
                            Assign Link
                          </CButton>
                        </CModalFooter>
                      </CModal>
                    )}
                  </div>
                  {!isEmpty(sitemapitem?.sub_heading_data) &&
                    sitemapitem?.sub_heading_data.map((subHeadingItem, index) => {
                      return (
                        <div key={index}>
                          {index === 0 && (
                            <h6 style={{ fontSize: '13px' }} className="mt-3">
                              Sub-Menu Items
                            </h6>
                          )}
                          <div className="d-flex justify-content-between align-items-start mt-2">
                            <div style={{ width: '78%' }}>
                              <CustomDescriptionBox
                                limit={25}
                                rows={1}
                                value={subHeadingItem.text}
                                onChange={(value) => {
                                  changeSiteMapItemSubHeadingText(value, idx, index)
                                  removeSiteMapHeadingLink(value, idx)
                                }}
                                style={{ fontSize: '10px', borderRadius: '3px' }}
                                limitFontSize={'11px'}
                              />
                            </div>

                            <div
                              className="w-7 h-7 bg-[#20211c] d-flex justify-center items-center rounded-sm cursor-pointer"
                              onClick={() => linkAssignModal(idx, index)}
                            >
                              <img src={LinkIcon} alt="" className="w-3 h-3" />
                            </div>
                            {linkModal && (
                              <CModal visible={linkModal} size="md" alignment="center">
                                <CModalBody>
                                  <h6 style={{ fontWeight: '700', fontSize: '12px' }}>ADD LINK</h6>
                                  <AttachLink
                                    title=""
                                    linkData={link}
                                    id={'text1'}
                                    categoryData={
                                      categoryList
                                        ? categoryList?.data.filter(
                                            (info, idx) => info.type === 'category' && info.status,
                                          )
                                        : []
                                    }
                                    setLinkData={(value) => {
                                      setsubLinkError('')
                                      setLink(value)
                                    }}
                                  />
                                  <div className="message-text error-message">
                                    <p>{subLinkError}</p>
                                  </div>
                                </CModalBody>
                                <CModalFooter style={{ borderTop: '0' }}>
                                  <CButton
                                    style={{
                                      color: '#3a3838',
                                      backgroundColor: 'white',
                                      border: '1px solid #bdbdbd',
                                      borderRadius: '5px',
                                    }}
                                    onClick={() => setLinkModal(false)}
                                  >
                                    Cancel
                                  </CButton>
                                  <CButton
                                    style={{
                                      color: 'white',
                                      backgroundColor: '#20211c',
                                      border: '1px solid #bdbdbd',
                                      borderRadius: '5px',
                                    }}
                                    onClick={() =>
                                      changeSiteMapItemSubHeadingLink(
                                        link,
                                        siteMapIdx,
                                        subHeadingIndex,
                                      )
                                    }
                                  >
                                    Assign Link
                                  </CButton>
                                </CModalFooter>
                              </CModal>
                            )}
                          </div>
                        </div>
                      )
                    })}
                </div>
              )
            })}
          {siteMap.length < 4 && (
            <div
              className="d-flex justify-content-center align-items-center cursor-pointer"
              style={{ height: '361px' }}
            >
              <div style={{ border: '1px solid #2172eb' }} className="relative h-full">
                <div
                  onClick={() => addSiteMap()}
                  className="absolute h-[32px] w-[32px] rounded-full bg-[#2172eb] top-[45%] -left-4 flex justify-center items-center"
                >
                  <img src={PlusIcon} className="w-[17px] h-[17px]" alt="plus icon" />
                </div>
              </div>
            </div>
          )}
        </div>
      ),
      itemStyle: 'mt-4',
      enableColorPicker: isAdvancedEditAllowed && componentData?.data?.style_config,
      colorPickerFunction: () => {
        setDesignSettingOptions(getStyleConfig(['title_primary', 'title_secondary']))
      },
    },
    {
      title: 'Menu Button',
      description: 'Edit button and its components in the Header',
      children: (
        <div className="border px-3 py-4" style={{ backgroundColor: '#e5e5e5' }}>
          <h6 className="font-13px">
            Button Text
            <span style={{ color: 'red' }}>*</span>
          </h6>
          <CustomDescriptionBox
            limit={12}
            rows={1}
            value={menuButton.text}
            onChange={(value) => setMenuButton((prev) => ({ ...prev, text: value }))}
            isMandatory={true}
            // errorText={errorData[`ctaButtonText${idx + 1}`]}
            style={{ fontSize: '13px' }}
            limitFontSize={'11px'}
          />
          <AttachLink
            title="Add Link"
            linkData={menuButton.link}
            id={'text2'}
            categoryData={
              categoryList
                ? categoryList?.data.filter((info, idx) => info.type === 'category' && info.status)
                : []
            }
            setLinkData={(value) => {
              //   clearError('heading1Link')
              setMenuButton((prev) => ({ ...prev, link: value }))
            }}
          />
        </div>
      ),
      itemStyle: 'mt-4',
      enableSwitch: true,
      switchChecked: menuButton.enabled,
      switchToggle: (event) => {
        let { checked } = event.target
        setMenuButton((prevState) => {
          return {
            ...prevState,
            enabled: checked,
          }
        })
      },
      enableColorPicker: isAdvancedEditAllowed && componentData?.data?.style_config,
      colorPickerFunction: () => {
        setDesignSettingOptions(getStyleConfig(['menu_btn']))
      },
    },
    {
      title: 'Add Button 1',
      description: 'Edit button and its components in the Header',
      children: (
        <div className="border px-3 py-4" style={{ backgroundColor: '#e5e5e5' }}>
          <h6 className="font-13px">
            Button Text
            <span style={{ color: 'red' }}>*</span>
          </h6>
          <CustomDescriptionBox
            limit={12}
            rows={1}
            value={addButton1.text}
            onChange={(value) => setAddButton1((prev) => ({ ...prev, text: value }))}
            isMandatory={true}
            // errorText={errorData[`ctaButtonText${idx + 1}`]}
            style={{ fontSize: '13px' }}
            limitFontSize={'11px'}
          />
          <AttachLink
            title="Add Link"
            linkData={addButton1.link}
            id={'text2'}
            categoryData={
              categoryList
                ? categoryList?.data.filter((info, idx) => info.type === 'category' && info.status)
                : []
            }
            setLinkData={(value) => {
              //   clearError('heading1Link')
              setAddButton1((prev) => ({ ...prev, link: value }))
            }}
          />
        </div>
      ),
      itemStyle: 'mt-4',
      enableSwitch: true,
      switchChecked: addButton1.enabled,
      switchToggle: (event) => {
        let { checked } = event.target
        setAddButton1((prevState) => {
          return {
            ...prevState,
            enabled: checked,
          }
        })
      },
      enableColorPicker: isAdvancedEditAllowed && componentData?.data?.style_config,
      colorPickerFunction: () => {
        setDesignSettingOptions(getStyleConfig(['add_btn1']))
      },
    },
    {
      title: 'Add Button 2',
      description: 'Edit button and its components in the Header',
      children: (
        <div className="border px-3 py-4" style={{ backgroundColor: '#e5e5e5' }}>
          <h6 className="font-13px">
            Button Text
            <span style={{ color: 'red' }}>*</span>
          </h6>
          <CustomDescriptionBox
            limit={12}
            rows={1}
            value={addButton2.text}
            onChange={(value) => setAddButton2((prev) => ({ ...prev, text: value }))}
            isMandatory={true}
            // errorText={errorData[`ctaButtonText${idx + 1}`]}
            style={{ fontSize: '13px' }}
            limitFontSize={'11px'}
          />
          <AttachLink
            title="Add Link"
            linkData={addButton2.link}
            id={'text2'}
            categoryData={
              categoryList
                ? categoryList?.data.filter((info, idx) => info.type === 'category' && info.status)
                : []
            }
            setLinkData={(value) => {
              //   clearError('heading1Link')
              setAddButton2((prev) => ({ ...prev, link: value }))
            }}
          />
        </div>
      ),
      itemStyle: 'mt-4',
      enableSwitch: true,
      switchChecked: addButton2.enabled,
      switchToggle: (event) => {
        let { checked } = event.target
        setAddButton2((prevState) => {
          return {
            ...prevState,
            enabled: checked,
          }
        })
      },
      enableColorPicker: isAdvancedEditAllowed && componentData?.data?.style_config,
      colorPickerFunction: () => {
        setDesignSettingOptions(getStyleConfig(['add_btn2']))
      },
    },
  ]
  return (
    <>
      <CModal scrollable size="lg" className="" visible={true}>
        {!isEmpty(designSettingOptions) && (
          <DesignSettingOverlay
            width={'36%'}
            options={designSettingOptions}
            onCancel={() => setDesignSettingOptions([])}
            handleSave={(data) => handleStyleSave(data)}
          />
        )}
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <CModalHeader className="d-flex justify-content-center">
          <p style={{ fontSize: '1.3rem' }}>
            <b style={{ fontWeight: '500' }}>Miami Fox Header Editor</b>
          </p>
        </CModalHeader>
        <CModalBody
          style={{ minHeight: '72vh' }}
          className=" static-scrollbar-class d-flex flex-column justify-content-between"
        >
          <div className="d-flex justify-content-center">
            <div
              style={{ width: '82%' }}
              className="flex flex-column justify-content-center align-items-center"
            >
              <TemplateAccordion items={accordionItems} styles={''} />
            </div>
          </div>
        </CModalBody>
        <CModalFooter className="d-flex justify-content-center border-top-0">
          <div
            className="mt-4 d-flex align-items-end justify-content-between"
            style={{ width: '80%' }}
          >
            <span className="mt-2" style={{ fontSize: '12px' }}>
              * Leave a section blank to remove it from the component. Do not fill any details.
            </span>
            <CButton
              style={{ color: 'black', border: '1px solid black' }}
              className="mx-4 bg-white rounded-1 btn-focus-none"
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton
              style={{ backgroundColor: '#20211c' }}
              className="px-3 rounded-1 btn-focus-none"
              onClick={handleSave}
            >
              Save
            </CButton>
          </div>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default MiamiFoxHeaderModal
